import React, { useEffect, useState } from "react";
import ModalSkeleton from "../../components/ModalSkeleton";
import { AreYouSureIcon } from "../../constant";
import classes from "./EditUserNameModal.module.css";
import ModalAction from "../../components/ModalAction";
import { GiConfirmed } from "react-icons/gi";
import { Input } from "../../components/Input";
import useApi from "../../useApi";
import { toast } from "react-toastify";
const EditUserNameModal = ({
  data,
  show,
  setShow,
  title = "Booking",
  description,
  onConfirm,
  
}) => {
const api = useApi()
  console.log("data ==> are you sure modal", data);
  const [name, setName] = useState("");
  const [loading, setloading] = useState(false)
  const editUserName = async () => {
    setloading(true)
    const params = {
      userDetailId: data.userDetailId,
      userFullName: name,
    };
    const response = await api.editUserNameApi(params);
    if (response?.data?.headers?.error == 200) {
      onConfirm(name);
      toast.success("Name update successfully.");
      setShow(false)
    } else {
      toast.error(response.data?.headers?.message);
    }
    setloading(false)
  };
  useEffect(()=>{
setName(data?.userFullName)
  },[data])
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      width="498px"
      title={"Edit User Name"}
    >
      <div className={classes.wrapper}>
        <div>
          <Input
            label={"Name"}
            placeholder="Enter Name here"
            value={name}
            onChange={setName}
          />
        </div>
        <ModalAction
        isApiCall={loading}
          disabled={!name || name===data.userFullName}
          onCancel={() => setShow(false)}
          onConfirm={editUserName}
          confirmText="Confirm"
          cancelText="Cancel"
          loading={loading}
        />
      </div>
    </ModalSkeleton>
  );
};

export default EditUserNameModal;
